import Vue from 'vue';
import VueRouter from 'vue-router';
import UsuarioAlliance from '@/views/painel/UsuarioAlliance.vue';
import UsuarioAdicionarParceiro from '@/views/painel/UsuarioAdicionarParceiro.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
  },
  {
    path: '/alliances',
    name: 'alliances',
    component: () =>
      import(/* webpackChunkName: "alliance" */ '../views/AllianceView.vue'),
  },
  {
    path: '/alliances/:alliance',
    name: 'alliance',
    component: () =>
      import(/* webpackChunkName: "alliance" */ '../views/AllianceSingle.vue'),
    props: true,
  },
  {
    path: '/solutions',
    name: 'solutions',
    component: () =>
      import(/* webpackChunkName: "solutions" */ '../views/SolutionsView.vue'),
  },
  {
    path: '/travel',
    name: 'travel',
    component: () =>
      import(/* webpackChunkName: "travel" */ '../views/TravelView.vue'),
  },
  {
    path: '/politica-privacidade',
    name: 'politicas',
    component: () =>
      import(/* webpackChunkName: "travel" */ '../views/PoliticaView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "travel" */ '../views/LoginView.vue'),
  },
  {
    path: '/21232f297a57a5a743894a0e4a801fc3',
    name: '',
    meta: {
      login: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "travel" */ '../views/painel/UsuarioView.vue'
      ),
    children: [
      {
        path: '',
        name: 'admin',
        component: UsuarioAlliance,
        meta: {
          login: true,
        },
      },
      {
        path: 'adicionar',
        name: 'adicionar',
        component: UsuarioAdicionarParceiro,
        meta: {
          login: true,
        },
      },
      {
        path: 'organizar-ordem',
        name: 'orderAlliances',
        component: () => import('../views/painel/OrderAlliances.vue'),
        meta: {
          login: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((r) => r.meta.login)) {
    const token = window.localStorage.token;
    if (!token) return next('/login');

    const valido = await store.dispatch('validateToken');
    if (valido) return next();

    return next('/login');
  }

  next();
});


export default router;
